// Write your code here
import './TranningTab.css'

const TranningTab = props => {
  const {tabname, onchangestatus, isActive} = props
  const {tabId, displayText} = tabname
  const appclick = () => {
    onchangestatus(tabId)
  }
  const activeTabBtnClassName = isActive ? 'active-tab-btn' : 'button'

  return (
    <li className="tabcontainer">
      <button
        type="button"
        className={`tab-btn ${activeTabBtnClassName}`}
        onClick={appclick}
        style={{width:"100%",color:"black"}}
      >
        {displayText}
      </button>

    </li>
  )
}
export default TranningTab;
